function unreachable(_x) {
  console.error("Not handled value", _x);
  return new Error("Unreachable code reached");
}
export {
  unreachable
};
//# sourceMappingURL=uncreachable.js.map
